import { HOST, registerModel } from '@/utils/base';

export default [
  // 采购付款申请
  {
    path: HOST + 'finance',
    component: () => import('@/layouts/BasicLayout'),
    beforeEnter: (to, from, next) => {
      next();
    },
    children: [
      //采购付款申请采购单列表
      {
        path: 'ppapply/purlist',
        component: () => import('@/routes/finance/ppapply/purlist'),
      },
      //付款申请列表
      {
        path: 'ppapply/list',
        component: () => import('@/routes/finance/ppapply/list'),
      },
      {
        // 新增
        path: 'ppapply/add',
        component: () => import('@/routes/finance/ppapply/add'),
      },
      {
        // 编辑
        path: 'ppapply/edit',
        component: () => import('@/routes/finance/ppapply/add'),
      },
      {
        // 详情
        path: 'ppapply/detail',
        component: () => import('@/routes/finance/ppapply/detail'),
      },
    ],
  },
  // 付款
  {
    path: HOST + 'finance',
    component: () => import('@/layouts/BasicLayout'),
    beforeEnter: (to, from, next) => {
      next();
    },
    children: [
      {
        // 发起付款
        path: 'pay/applylist',
        component: () => import('@/routes/finance/pay/applylist'),
      },
      {
        // 发起付款 - 付款录入
        path: 'pay/add',
        component: () => import('@/routes/finance/pay/add'),
      },
      {
        // 发起付款 - 付款录入
        path: 'pay/edit',
        component: () => import('@/routes/finance/pay/edit'),
      },
      {
        // 付款单 - 列表
        path: 'pay/list',
        component: () => import('@/routes/finance/pay/list'),
      },
      {
        // 付款单 - 详情
        path: 'pay/detail',
        component: () => import('@/routes/finance/pay/detail'),
      },
    ],
  },
  // 收款
  {
    path: HOST + 'finance',
    component: () => import('@/layouts/BasicLayout'),
    beforeEnter: (to, from, next) => {
      next();
    },
    children: [
      {
        // 收款录入
        path: 'receipt/add',
        component: () => import('@/routes/finance/receipt/add'),
      },
      {
        // 收款单列表 - 编辑
        path: 'receipt/edit',
        component: () => import('@/routes/finance/receipt/add'),
      },
      {
        // 收款单列表
        path: 'receipt/list',
        component: () => import('@/routes/finance/receipt/list'),
      },
      {
        // 收款单列表 - 详情
        path: 'receipt/detail',
        component: () => import('@/routes/finance/receipt/detail'),
      },
      {
        //  勾稽申请
        path: 'receipt/list_audit',
        component: () => import('@/routes/finance/receipt/list_audit'),
      },
      {
        //  勾稽申请管理
        path: 'receipt/audit_list',
        component: () => import('@/routes/finance/receipt/audit_list'),
      },
      {
        // 勾稽
        path: 'receipt/add_audit',
        component: () => import('@/routes/finance/receipt/add_audit'),
      },
      {
        // 勾稽 详情
        path: 'receipt/detail_audit',
        component: () => import('@/routes/finance/receipt/detail_audit'),
      },
      {
        // 勾稽申请 编辑
        path: 'receipt/edit_audit',
        component: () => import('@/routes/finance/receipt/add_audit'),
      },
    ],
  },
  // 应收应付账单管理
  {
    path: HOST + 'finance',
    component: () => import('@/layouts/BasicLayout'),
    beforeEnter: (to, from, next) => {
      next();
    },
    children: [
      // 应付账单付款申请
      {
        path: 'arap/billApply',
        component: () => import('@/routes/finance/arap/bill_apply'),
      },
      {
        // 应付账单申请管理
        path: 'arap/bondManageList',
        component: () => import('@/routes/finance/arap/bond_manage_list'),
      },
      {
        path: 'arap/add',
        component: () => import('@/routes/finance/arap/add'),
      },
      {
        path: 'arap/edit',
        component: () => import('@/routes/finance/arap/add'),
      },
      {
        path: 'arap/detail',
        component: () => import('@/routes/finance/arap/detail'),
      },
    ],
  },
  // 结算管理
  {
    path: HOST + 'finance',
    component: () => import('@/layouts/BasicLayout'),
    beforeEnter: (to, from, next) => {
      next();
    },
    children: [
      //  销售单结算申请
      {
        path: 'payoff/sale/list',
        component: () => import('@/routes/finance/payoff/sale/list'),
      },
      //  销售单结算申请管理
      {
        path: 'payoff/sale/payoff_list',
        component: () => import('@/routes/finance/payoff/sale/payoff_list'),
      },
      // 结算申请
      {
        path: 'payoff/sale/add',
        component: () => import('@/routes/finance/payoff/sale/add'),
      },
      // 结算申请 详情
      {
        path: 'payoff/sale/detail',
        component: () => import('@/routes/finance/payoff/sale/detail'),
      },
      // 结算申请 编辑
      {
        path: 'payoff/sale/edit',
        component: () => import('@/routes/finance/payoff/sale/add'),
      },
      //采购结算申请
      {
        path: 'payoff/pur/list',
        component: () => import('@/routes/finance/payoff/pur/list'),
      },
      //采购结算申请管理
      {
        path: 'payoff/pur/payoff_list',
        component: () => import('@/routes/finance/payoff/pur/payoff_list'),
      },
      //采购结算申请-结算
      {
        path: 'payoff/pur/add',
        component: () => import('@/routes/finance/payoff/pur/add'),
      },
      //采购结算申请-编辑
      {
        path: 'payoff/pur/edit',
        component: () => import('@/routes/finance/payoff/pur/add'),
      },
      //采购结算申请-详情
      {
        path: 'payoff/pur/detail',
        component: () => import('@/routes/finance/payoff/pur/detail'),
      },
    ],
  },
  // 费用管理
  {
    path: HOST + 'finance',
    component: () => import('@/layouts/BasicLayout'),
    beforeEnter: (to, from, next) => {
      next();
    },
    children: [
      //费用管理
      {
        path: 'fee/list',
        component: () => import('@/routes/finance/fee/list'),
      },
      {
        path: 'fee/operator',
        component: () => import('@/routes/finance/fee/operator'),
      },
     {
        path: 'fee/detail',
        component: () => import('@/routes/finance/fee/info'),
      },
      {
        path: 'fee/edit',
        component: () => import('@/routes/finance/fee/payoff_query'),
      },
      {
        path: 'fee/payoff_query',
        component: () => import('@/routes/finance/fee/payoff_query'),
      }
    ],
  },
  // 发票管理
  {
    path: HOST + 'finance',
    component: () => import('@/layouts/BasicLayout'),
    beforeEnter: (to, from, next) => {
      next();
    },
    children: [
      {
        // 进项发票详情
        path: "invoice/in/detail",
        component: () => import("@/routes/finance/invoice/in/info"),
      },
      {
        // 进项发票列表
        path: "invoice/in/list",
        component: () => import("@/routes/finance/invoice/in/list"),
      },
      {
        // 进项发票录入
        path: "invoice/in/add",
        component: () => import("@/routes/finance/invoice/in/add"),
      },
      {
        // 进项发票编辑
        path: "invoice/in/edit",
        component: () => import("@/routes/finance/invoice/in/add"),
      },
      // 进项发票勾稽
      {
        path: 'invoice/in/audit',
        component: () => import('@/routes/finance/invoice/in/audit'),
      },
      // 费用发票勾稽
      {
        path: 'invoice/audit/fee',
        component: () => import('@/routes/finance/invoice/audit/fee'),
      },
      // 发票勾稽管理
      {
        path: 'invoice/audit/list',
        component: () => import('@/routes/finance/invoice/audit/list'),
      },
      // 销项发票申请查询
      {
        path: 'invoice/apply/payoff_list',
        component: () => import('@/routes/finance/invoice/apply/payoff_list'),
      },
      // 销项发票申请管理
      {
        path: 'invoice/apply/list',
        component: () => import('@/routes/finance/invoice/apply/list'),
      },
      {
        // 销项发票申请详情
        path: "invoice/apply/detail",
        component: () => import("@/routes/finance/invoice/apply/info"),
      },
      {
        // 销项发票申请录入
        path: "invoice/apply/add",
        component: () => import("@/routes/finance/invoice/apply/add"),
      },
      {
        // 销项发票申请编辑
        path: "invoice/apply/edit",
        component: () => import("@/routes/finance/invoice/apply/add"),
      },
      // 销项发票新增之申请列表
      {
        path: 'invoice/out/apply_list',
        component: () => import('@/routes/finance/invoice/out/apply_list'),
      },
      //销项发票管理
      {
        path: 'invoice/out/list',
        component: () => import('@/routes/finance/invoice/out/list'),
      },
      {
        // 销项发票详情
        path: "invoice/out/detail",
        component: () => import("@/routes/finance/invoice/out/info"),
      },
      {
        // 销项发票录入
        path: "invoice/out/add",
        component: () => import("@/routes/finance/invoice/out/add"),
      },
      {
        // 销项发票编辑
        path: "invoice/out/edit",
        component: () => import("@/routes/finance/invoice/out/add"),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/common/finance_router.js